import { OrderStatus } from '@40seas/entities/orders';
import { EnumColor } from '@40seas/frontend/common/providers';

export const orderStatusColorMapping = {
    [OrderStatus.Canceled]: 'error',
    [OrderStatus.Done]: 'success',
    [OrderStatus.Failed]: 'error',
    [OrderStatus.InProgress]: 'info',
    [OrderStatus.Pending]: 'default',
} as { [key in OrderStatus]: EnumColor };
